<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="PropertiesBox" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { PropertiesBoxProps } from './PropertiesBox.ts';
import PropertiesBox from './PropertiesBox.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-properties-box';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<PropertiesBoxProps>();
const changableProps = useChangableProps(componentName, props);

</script>
